<!-- ProgressBar.vue -->
<template>
  <div class="progress-bar">
    <div class="progress" :style="{ width: progress + '%' }">
      {{ progress }}%
    </div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true,
      validator: value => value >= 0 && value <= 100
    }
  }
}
</script>

<style scoped>
.progress-bar {
  width: 100%;
  background-color: #f3f3f3;
  border-radius: 5px;
  overflow: hidden;
  margin-bottom: 10px;
}

.progress {
  height: 20px;
  background-color: #4caf50;
  color: white;
  text-align: center;
  line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/progressBar.vue